<template>
    <transition name="slide" mode="out-in">
        <div
            v-if="data().length > 0"
            class="w-100 d-flex align-items-center justify-content-center"
        >
            <UniversityAvatar
                v-for="c in data()"
                :key="c.id"
                small
                :connection="c"
                style="padding: 0 5px:"
            />
        </div>
    </transition>
</template>

<script>
import UniversityAvatar from '~/shared/universitybadges/UniversityAvatar';

export default {
    name: 'UniConnections',
    components: { UniversityAvatar },
    computed: {
        connections() {
            // University connections
            return this.$interfaces.university.connection.get({
                reactive: true,
                verifiedOnly: true,
            });
        },
    },
    methods: {
        data() {
            return this.connections.data || [];
        },
    },
};
</script>

<style lang="scss" scoped></style>
